function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShutter = function SvgShutter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 36,
    style: {
      fill: "#03d47c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 90C20.2 90 0 69.8 0 45S20.2 0 45 0s45 20.2 45 45-20.2 45-45 45zm0-86C22.4 4 4 22.4 4 45s18.4 41 41 41 41-18.4 41-41S67.6 4 45 4z",
    style: {
      fill: "#8b9c8f"
    }
  }));
};
export default SvgShutter;